<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name:'Import'
    }
</script>

<style lang="scss" scoped>

</style>